import React, { createContext, useCallback, useContext, useState } from 'react';

const ChatContext = createContext();

export const useChatContext = () => useContext(ChatContext);

export const ChatProvider = ({ children }) => {
    // Bumped whenever the conversation list may have changed (new chat,
    // generated title, regenerate); the sidebar refetches on each change.
    const [conversationsVersion, setConversationsVersion] = useState(0);

    const refreshConversations = useCallback(() => {
        setConversationsVersion(version => version + 1);
    }, []);

    return (
        <ChatContext.Provider value={{ conversationsVersion, refreshConversations }}>
            {children}
        </ChatContext.Provider>
    );
};
